import { useDomainSelectionStore } from "@/features/domain-checker-input/stores/useDomainSelectionStore";

/**
 * Wrapper composable for domain selection logic.
 */
export function useDomainSelection() {
    return useDomainSelectionStore();
}